import React from "react";

import css from "./title-block.module.css";

const TitleBlock = ({ children }) => {
  return <div className={css.titleBlock}>{children}</div>;
};

export default TitleBlock;
